function numberFormat(value = 0) {
  return new Intl.NumberFormat("en-IN").format(
    value
  );
}

export default numberFormat;
